import { USER_MODULE } from "./module.type";

/**
 * Mutation that sets some local fetch timestamp to the current date time value.
 * Optionaly it can take a timestamp value to set.
 */
export const SET_FETCH_TIMESTAMP   = "set_fetch_timestamp";
export const SET_DOCUMENT          = "set_document";
export const SET_DOCUMENT_LISTENER = "set_document_listener";

// tasks.store.js
export const PUSH_TASK = "push_task";
export const UPDATE_TASKS = "update_tasks";
export const UPDATE_GROUP_TASKS_SNAPSHOT = "update_group_tasks";
export const UPDATE_GROUP_TASK_NOTIFICATIONS_SNAPSHOT = "update_group_task_notifications_snapshot";
export const INSERT_GROUP_ACTIONS_LISTENER = "insert_group_actions_listener";
export const SET_NOTIFICATIONS_LISTENER = "set_notifications_listener";
export const DETACH_NOTIFICATIONS_LISTENER = "detach_notifications_listener";

// user.store.js
export const SELECT_CONTEXT = "select_context";
export const SELECT_GROUP = "select_group";
export const SET_FCM_TOKEN = "set_fcm_token";

export const DETACH_LISTENER = "detach_listener"
export const DETACH_ALL_LISTENERS = "detach_all_listeners"

export const G_SET_LOADING = "set_loading";
export const G_SET_FCM_TOKEN = `${USER_MODULE}/${SET_FCM_TOKEN}`;